'use client'

import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import { ArrowRight, Sparkles } from 'lucide-react'

interface CardCTAProps {
  onGetStarted: () => void
}

export function CardCTA({ onGetStarted }: CardCTAProps) {
  return (
    <section className="py-12 lg:py-20">
      <div className="mx-auto max-w-6xl px-4 lg:px-8 sm:px-6">
        <Panel.Wrapper
          className={cn(
            'relative overflow-hidden',
            'bg-gradient-to-br from-gradient-yellow/10 via-background to-gradient-green/10',
          )}
        >
          <div className="-top-24 -right-24 absolute h-48 w-48 rounded-full bg-gradient-to-br from-gradient-yellow/20 to-gradient-green/20 blur-[80px]" />
          <div className="-bottom-24 -left-24 absolute h-48 w-48 rounded-full bg-gradient-to-br from-gradient-green/20 to-gradient-yellow/20 blur-[80px]" />

          <Panel.Content className="relative flex flex-col items-center p-8 text-center lg:p-16 md:p-12">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-gradient-yellow to-gradient-green">
              <Sparkles className="h-5 w-5 text-black" />
            </div>

            <Typography
              variant="h2"
              className="max-w-2xl text-3xl lg:text-4xl"
              gradient
              style={{ alignSelf: 'center' }}
            >
              Stop Selling. Start Spending.
            </Typography>

            <Typography variant="p" className="mx-auto mt-4 max-w-xl text-muted-foreground">
              Real-time credit from your crypto. No off-ramps, no top-ups, no selling. Check your eligibility in
              minutes.
            </Typography>

            <Button
              variant="primary"
              size="lg"
              postfixIcon={<ArrowRight className="h-4 w-4" />}
              onClick={onGetStarted}
              className="mt-8 bg-gradient-to-r from-gradient-yellow to-gradient-green text-black hover:opacity-90"
            >
              Check Your Eligibility
            </Button>
          </Panel.Content>
        </Panel.Wrapper>
      </div>
    </section>
  )
}
